<template>
  <div class="pt-card-attribute input">
    <r-text style="margin-bottom: 8px;" type="caption">
      {{ config.label }}
    </r-text>
    <el-input
      class="r-input"
      size="mini"
      v-model="feature[config.prop]"
      :disabled="config.disabled"
    />
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style></style>
